var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgImageOutline = function SvgImageOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9231 2.38477H3.07692C1.92987 2.38477 1 3.31464 1 4.46169V15.5386C1 16.6857 1.92987 17.6155 3.07692 17.6155H16.9231C18.0701 17.6155 19 16.6857 19 15.5386V4.46169C19 3.31464 18.0701 2.38477 16.9231 2.38477Z",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4615 7.92304C14.2262 7.92304 14.8461 7.30313 14.8461 6.53842C14.8461 5.77372 14.2262 5.15381 13.4615 5.15381C12.6968 5.15381 12.0769 5.77372 12.0769 6.53842C12.0769 7.30313 12.6968 7.92304 13.4615 7.92304Z",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0769 13.4522L8.15413 9.53678C7.90451 9.28722 7.56901 9.14241 7.21619 9.13196C6.86337 9.1215 6.51987 9.24619 6.25591 9.48053L1 14.1536M8.61538 17.6151L13.9522 12.2783C14.1963 12.0338 14.523 11.8893 14.8681 11.8733C15.2132 11.8573 15.5519 11.9709 15.8175 12.1918L19 14.8459",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImageOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/image-outline.00fa65a6.svg";
export { ForwardRef as ReactComponent };